export const messages = {
  de: {
    'accounts.accountIsActive': 'Account ist aktiv',
    'accounts.accountIsDemo': 'Account ist demo',
    'accounts.accountCreatedSuccessfully': 'Account erstellt',
    'accounts.accountCreationFailed': 'Account erstellung fehlgeschlagen',
    'accounts.actions': 'Aktionen',
    'accounts.active': 'Aktiv',
    'accounts.applicationServer': 'Applikations-Server',
    'accounts.applicationServerInfo': 'Der Server des Parents wird automatisch verwendet.',
    'accounts.config': 'Konfiguration',
    'accounts.create': 'Account erstellen',
    'accounts.createAccount': 'Neuer Account',
    'accounts.createAccounts': ' Accounts anlegen',
    'accounts.createCsv': 'Mehrere mit csv-Liste',
    'accounts.createSingle': 'Einzelner Account',
    'accounts.customer': 'Kunden',
    'accounts.customerSelect': 'Welche Kunden?',
    'accounts.delete': 'Account löschen',
    'accounts.demo': 'Demo',
    'accounts.description': 'Beschreibung',
    'accounts.edit': 'Account editieren',
    'accounts.email': 'E-Mail',
    'accounts.faulty': 'fehlerhaft',
    'accounts.fetchBounces': 'Fetch Bounces',
    'accounts.h1': 'Accounts',
    'accounts.inactive': 'Inaktiv',
    'accounts.isDefault': 'Default',
    'accounts.manageCustomer': 'Kundenverwalter',
    'accounts.module': 'Module',
    'accounts.name': 'Name',
    'accounts.ok': 'OK',
    'accounts.overview': 'Übersicht',
    'accounts.parent': 'Parent',
    'accounts.parentInfo': 'Ein L Account kann keinen Parent besitzen.',
    'accounts.password': 'Passwort',
    'accounts.plugins': 'Plug-Ins',
    'accounts.port': 'Port',
    'accounts.selectParent': 'Parent auswählen',
    'accounts.server': 'Server',
    'accounts.status': 'Status',
    'accounts.storage.assets': 'Assets',
    'accounts.storage.files': 'Files',
    'accounts.storage.images': 'Images',
    'accounts.storage.mediaManager': 'mediamanager',
    'accounts.storage.missedItems': 'Es fehlen: Plug-Ins, Log-Files, Themes & Templates (Kilo-Bytes)',
    'accounts.storage.newsletters': 'Verschickte Newsletter',
    'accounts.storage.others': 'Sonstiges (Exports, Testversand, KD-HTMLs)',
    'accounts.storage.schema': 'Datenbank',
    'accounts.storage.screenshots': 'Screenshots (Newsletter, Artikel)',
    'accounts.storage.thumbnails': 'Thumbnails',
    'accounts.storage.total': 'Summe Speicherplatzverbrauch (MB)',
    'accounts.storageUsage': 'Größe (MB)',
    'accounts.themes': 'Themes',
    'accounts.type': 'Typ',
    'accounts.uploadCsv': 'csv Datei hochladen',
    'accounts.uploadCsvAccountName': 'Accountname',
    'accounts.uploadCsvInfo': 'Die csv Datei (UTF-8) darf keine Spaltenüberschriften enthalten und muss wie folgt aufgebaut sein: erste Spalte = Accountname',
    'accounts.uploadCsvModalTitle1': 'Accounts mit .csv Datei erstellen',
    'accounts.uploadCsvModalTitle2': 'Prüfung',
    'accounts.uploadCsvModalTitle3': 'Account Einstellungen',
    'accounts.uploadCsvModalTitle4': 'Accounts werden erstellt...',
    'accounts.uploadCsvModalTitle5': 'Accounts erstellt',
    'accounts.uploadCsvValid': 'csv Datei scheint valid',
    'accounts.username': 'Login',
    'accounts.validUntil': 'Gültig bis',
    'accounts.operationReport': 'Prüfung',
    'accounts.operationsPerformed': 'Durchgeführte Aktionen',
    'accounts.operations.info': 'Info',
    'accounts.operations.create_account': 'Account erstellen',
    'accounts.operations.media_manager_signin': 'MM: Anmeldung',
    'accounts.operations.media_manager_create_bucket': 'MM: Bucket erstellen',
    'accounts.operations.media_manager_create_service_user': 'MM: Service-User erstellen',
    'accounts.operations.idp_upsert': 'IDP: Account erstellen',
    'accounts.operations.update_modules': 'Module aktualisieren',
    'accounts.operations.calculate_account_count': 'Account-Anzahl berechnen',
    'accounts.operations.sync_languages': 'Sprachen synchronisieren',
    'accounts.operations.upsert_account_m2m': 'M2M: Account erstellen',
    'accounts.operations.upsert_media_manager_m2m': 'M2M: MediaManager erstellen',
    'accounts.operations.sync_mailing_templates': 'Sendungsvorlagen synchronisieren',
    'accounts.operations.error': 'Fehler',
    'accounts.operations.rollback': 'Rollback (Gesamt)',
    'accounts.operations.rollback_create_account': 'Account erstellen',
    'accounts.operations.rollback_delete_m2m_account': 'M2M: Account löschen',
    'accounts.operations.rollback_delete_idp': 'IDP: Account löschen',
    'accounts.operations.rollback_delete_service_user': 'MM: Service-User löschen',
    'accounts.operations.rollback_delete_bucket': 'MM: Bucket löschen',
    'accounts.operations.statusRollback': 'Rollback',
    'accounts.operations.statusError': 'Fehler',
    'accounts.operations.statusOk': 'OK',
    'blacklist.cancel': 'Abbrechen',
    'blacklist.category': 'Kategorie',
    'blacklist.category.fake': 'Fake',
    'blacklist.category.non-existent': 'Nicht existent',
    'blacklist.category.parked': 'Geparkt',
    'blacklist.category.spam-trap': 'Spam-Trap',
    'blacklist.category.temp': 'Temp',
    'blacklist.category.typo': 'Tippfehler',
    'blacklist.comment': 'Kommentar',
    'blacklist.commentHelpText': 'Optional, max. 1000 Zeichen',
    'blacklist.create': 'Domain / E-Mail hinzufügen',
    'blacklist.createEntry': 'Eintrag erstellen',
    'blacklist.createdAt': 'Erstellt',
    'blacklist.details.close': 'Schließen',
    'blacklist.details.delete': 'Löschen',
    'blacklist.deleteConfirmTitle': 'Eintrag löschen',
    'blacklist.deleteConfirmText': 'Soll der Eintrag "{value}" unwiderruflich gelöscht werden?',
    'blacklist.deleteNotPossibleTitle': 'Löschen nicht möglich',
    'blacklist.deleteNotPossibleText': '"{value}" kann nicht gelöscht werden, da bereits E-Mail-Adressen mit diesem Eintrag archiviert wurden.',
    'blacklist.details.saveAndClose': 'Speichern und schließen',
    'blacklist.h1': 'Blacklist',
    'blacklist.hits': 'Hits',
    'blacklist.overview': 'Übersicht',
    'blacklist.pleaseSelect': 'Bitte auswählen',
    'blacklist.type': 'Format',
    'blacklist.typeDomain': 'Domain',
    'blacklist.typeEmail': 'E-Mail',
    'blacklist.value': 'Domain / E-Mail',
    'blacklist.valueEmail': 'E-Mail',
    'blacklist.valueDomain': 'Domain',
    'blacklist.valueHelpText': 'max. 255 Zeichen',
    'blacklist.status': 'Status',
    'blacklist.statusActive': 'Aktiv',
    'blacklist.statusInactive': 'Inaktiv',
    'collections.code': 'Quelltext',
    'collections.create': 'Neue Listenvorlage',
    'collections.delete': 'Löschen',
    'collections.deleteConfirm': 'Listenvorlage jetzt löschen',
    'collections.deleteConfirmText': 'Wurden bereits Artikel mit dieser Vorlage erstellt, dann sollte diese ausgeblendet werden.<br /><br /> Bist du sicher, dass du die Listenvorlage löschen willst?',
    'collections.descriptionEnglish': 'Beschreibung (englisch)',
    'collections.descriptionGerman': 'Beschreibung (deutsch)',
    'collections.edit': 'Listenvorlage editieren',
    'collections.editCode': 'Quelltext editieren',
    'collections.editJson': 'JSON editieren',
    'collections.h1': 'Listenvorlagen',
    'collections.json': 'JSON',
    'collections.listPosition': 'Position',
    'collections.name': 'Name',
    'collections.nameEnglish': 'Name (englisch)',
    'collections.nameGerman': 'Name (deutsch)',
    'collections.of': 'von',
    'collections.overview': 'Übersicht',
    'collections.text': 'Textversion',
    'customers.accountCount': 'Accounts',
    'customers.all': 'Alle Kunden',
    'customers.city': 'Stadt',
    'customers.config': 'Konfiguration',
    'customers.contact': 'Kontakt',
    'customers.contactPhone': 'Telefonnummer',
    'customers.contractEnd': 'Vertragsende',
    'customers.contractStart': 'Vertragsbeginn',
    'customers.country': 'Land',
    'customers.create': 'Neuer Kunde',
    'customers.createdAt': 'Erstellt am',
    'customers.delete': 'Löschen',
    'customers.deleteConfirm': 'Kunde unwiederruflich löschen?',
    'customers.deleteMM': 'Kunde auch im Media Manager löschen',
    'customers.deleteWarning': 'Löschen nicht möglich',
    'customers.deleteWarningInfo': 'Der Kunde kann erst gelöscht werden, wenn keine Accounts mehr vorhanden sind.',
    'customers.edit': 'Bearbeiten',
    'customers.h1': 'Accounts',
    'customers.mediaManager': 'Mediamanager-Server',
    'customers.name': 'Name',
    'customers.overview': 'Kunden',
    'customers.sendunits': 'Versandserver',
    'customers.storageUsage': 'Größe (MB)',
    'customers.street': 'Straße',
    'customers.variables': 'Variablen',
    'customers.zip': 'Postcode',
    'customers.operationReport': 'Prüfung',
    'customers.customerCreatedSuccessfully': 'Kunde erfolgreich erstellt',
    'customers.customerCreationFailed': 'Kundenerstellung fehlgeschlagen',
    'customers.operationsPerformed': 'Durchgeführte Operationen',
    'customers.operations.info': 'Info',
    'customers.operations.statusOk': 'OK',
    'customers.operations.statusError': 'Fehler',
    'customers.operations.statusRollback': 'Rollback',
    'customers.operations.create_customer': 'Kunde erstellen',
    'customers.operations.media_manager_create_customer': 'MM: Kunde erstellen',
    'customers.operations.idp_upsert': 'IDP: Kunde erstellen',
    'customers.operations.upsert_customer_m2m': 'M2M: Kunde erstellen',
    'customers.operations.error': 'Fehler',
    'customers.operations.rollback_delete_media_manager_customer': 'MM: Kunde löschen',
    'customers.operations.rollback_create_customer': 'Kunde erstellen',
    'customers.operations.rollback': 'Rollback (Gesamt)',
    'dashboard.accounts': 'Accounts',
    'dashboard.customers': 'Kunden',
    'dashboard.h1': 'Dashboard',
    'dashboard.mailings': 'Sendungen versandt',
    'dashboard.mailingsToday': 'Sendungen heute',
    'dashboard.plugins': 'Plugins',
    'dashboard.sendunit': 'Versandserver',
    'dashboard.sendunitPool': 'Versandserverpool',
    'dashboard.templates': 'Templates',
    'dashboard.themes': 'Themes',
    'dashboard.users': 'Benutzer',
    'externalIDP.accounts': 'Accounts',
    'externalIDP.assigned': 'Zugewiesen',
    'externalIDP.clientId': 'Client ID',
    'externalIDP.clientSecret': 'Client Secret',
    'externalIDP.create': 'Neuer IDP',
    'externalIDP.customer': 'Kunde',
    'externalIDP.delete': 'IDP löschen',
    'externalIDP.deleteText': 'Soll die Externe IDP "{name}" unwiderruflich gelöscht werden?',
    'externalIDP.deleteTitle': 'Externe IDP löschen',
    'externalIDP.edit': 'IDP bearbeiten',
    'externalIDP.failedToAssign.text': 'Es ist ein Fehler beim Zuweisen aufgetreten.',
    'externalIDP.failedToAssign.title': 'Fehler beim Zuweisen',
    'externalIDP.failedToDelete.text': 'Der externe IDP ist einem oder mehreren Accounts zugeordnet. Das Löschen des externen IDP ist nur möglich, wenn dieser nicht mehr verwendet wird.',
    'externalIDP.failedToDelete.title': 'Externer IDP kann nicht gelöscht werden',
    'externalIDP.failedToDetach.text': 'In dem Account befinden sich noch Redakteure, die den externen IDP und den Account als Heimataccount nutzen.',
    'externalIDP.failedToDetach.title': 'Externer IDP kann nicht entfernt werden',
    'externalIDP.h1': 'Externe IDP',
    'externalIDP.idMatchType': 'Eindeutige Zuordung',
    'externalIDP.knownURL': 'Well known URL',
    'externalIDP.knownURLInfo': 'Die tatsächlich verwendete Kunden-Domain kann sich von der Well Known URL Domain unterscheiden. In diesem Fall kann die Domain einfach hier ersetzt werden. mail2many verwendet die hier angegebene Domain auch für weitere URLs (Beispiel: Kunden domain = login.travel-peak.de, Well Known URL Domain = travel-peak.okta.com). Die "issuer"-URL wird derzeit nicht angepasst, sondern verwendet die Well Known URL.',
    'externalIDP.matchTypes.preferredUsername': 'username (preferred username)',
    'externalIDP.matchTypes.sub': 'sub (eindeutige ID)',
    'externalIDP.name': 'Bezeichnung',
    'externalIDP.overview': 'Übersicht',
    'externalIDP.slug': 'Slug',
    'externalIDP.slugInfo': '(letzter Teil der URL)',
    'externalIDP.type': 'Typ',
    'externalIDP.usage': 'Verwendung',
    'global.copied': 'URL in Zwischenablage kopiert.',
    'global.copiedFailed': 'URL konnte nicht in Zwischenablage kopiert werden.',
    'global.deleteConfirm': 'Sind sie sich sicher?',
    'global.deleted': 'Erfolgreich gelöscht.',
    'global.deletedError': 'Es ist ein Fehler beim Löschen aufgetreten.',
    'global.dropdownDefault': 'Bitte auswählen',
    'global.dropdownNoSelection': 'keine Auswahl',
    'global.loadError': 'Fehler beim Laden.',
    'global.notImplemented': 'Diese Funktion ist leider noch nicht implementiert.',
    'global.saved': 'Erfolgreich gespeichert.',
    'global.savedError': 'Es ist ein Fehler beim Speichern aufgetreten.',
    'header.signOut': 'Abmelden',
    'idpUsers.account.accountName': 'Accountname',
    'idpUsers.account.accountType': 'Typ',
    'idpUsers.account.guestAccount': 'Gast',
    'idpUsers.account.homeAccount': 'Heimat',
    'idpUsers.account.id': '#',
    'idpUsers.accounts': 'Accounts',
    'idpUsers.active': 'Aktiv',
    'idpUsers.delete': 'Benutzer löschen',
    'idpUsers.deleteConfirmText': 'Soll der Benutzer {email} unwiderruflich gelöscht werden?',
    'idpUsers.email': 'E-Mail',
    'idpUsers.h1': 'IPD',
    'idpUsers.info': 'Admin User und offline Benutzer werden nicht aufgelistet',
    'idpUsers.overview': 'Benutzer',
    'idpUsers.session': 'Alle Sessions',
    'idpUsers.sessionState1': '0 - 15 min',
    'idpUsers.sessionState2': '15 - 60 min',
    'idpUsers.sessionState3': '60 - 240 min',
    'idpUsers.sessionState4': 'offline',
    'idpUsers.status': 'Status',
    'idpUsers.totalUsers': '({count} gesamt)',
    'languages.account.assigned': 'Zugewiesen',
    'languages.account.failedToAssign.text': 'Es ist ein Fehler beim Zuweisen aufgetreten.',
    'languages.account.failedToAssign.title': 'Fehler beim Zuweisen',
    'languages.account.failedToDetach.text': 'Es ist ein Fehler beim Abtrennen aufgetreten. Wahrscheinlich sind bereits Inhalte in dieser Sprache erstellt worden.',
    'languages.account.failedToDetach.title': 'Fehler beim Abtrennen',
    'languages.account.name': 'Account',
    'languages.account.selectAll': 'Allen zuweisen',
    'languages.account.selectNone': 'Keinem zuweisen',
    'languages.available': 'Verfügbar',
    'languages.create': 'Neue Sprache',
    'languages.customer.accounts': 'Accounts',
    'languages.customer.assigned': 'Verfügbar',
    'languages.customer.editLanguage': 'Sprache bearbeiten',
    'languages.customer.name': 'Kunde',
    'languages.delete': 'Löschen',
    'languages.details.close': 'Schließen',
    'languages.details.deepl': 'DeepL',
    'languages.details.languageCode': 'Sprachcode',
    'languages.details.nameEnglish': 'Name (englisch)',
    'languages.details.nameGerman': 'Name (deutsch)',
    'languages.details.noSelection': 'Keine Auswahl',
    'languages.details.saveAndClose': 'Speichern und schließen',
    'languages.details.usage': 'Verwendung anzeigen',
    'languages.duplicateLanguageCode': 'Sprachcode besteht bereits',
    'languages.englishIso': 'Bezeichnung englisch',
    'languages.germanIso': 'Bezeichnung deutsch',
    'languages.h1': 'Sprachen',
    'languages.isIso': 'ISO 639',
    'languages.iso': 'Sprachcode',
    'languages.iso.info': 'max. 6 Zeichen',
    'languages.languageCode': 'Sprachcode (max. 5 Zeichen)',
    'languages.mappedIso': 'ISO-Referenzsprache',
    'languages.mappedIso.info': '(z.B. für <lang> Attribut)',
    'languages.name': 'Sprachcode',
    'languages.nameEnglish': 'Bezeichnung englisch',
    'languages.nameGerman': 'Bezeichnung deutsch',
    'languages.overview': 'Übersicht',
    'languages.usage.accounts': 'Accounts',
    'languages.usage.article': 'Artikel',
    'languages.usage.delete': 'Sprache löschen',
    'languages.usage.deleteText': 'Soll die Sprache "{name}" unwiderruflich gelöscht werden?',
    'languages.usage.mailing': 'Sendungen',
    'login.email': 'E-Mail',
    'login.error': 'E-Mail oder Passwort inkorrekt',
    'login.password': 'Passwort',
    'login.signIn': 'Anmelden',
    'mailingTemplates.account.assigned': 'Zugewiesen',
    'mailingTemplates.account.name': 'Account',
    'mailingTemplates.account.selectAll': 'Allen zuweisen',
    'mailingTemplates.account.selectNone': 'Keinem zuweisen',
    'mailingTemplates.customer.accounts': 'Accounts',
    'mailingTemplates.customer.assigned': 'Zugewiesen',
    'mailingTemplates.customer.editTemplate': 'Sendung bearbeiten',
    'mailingTemplates.customer.name': 'Kunde',
    'mailingTemplates.details.change': 'Ändern',
    'mailingTemplates.details.changeJson': 'Ändern',
    'mailingTemplates.details.close': 'Schließen',
    'mailingTemplates.details.default': 'Default, den alle Konten haben würden',
    'mailingTemplates.details.descriptionEnglish': 'Beschreibung (englisch)',
    'mailingTemplates.details.descriptionGerman': 'Beschreibung (deutsch)',
    'mailingTemplates.details.icon': 'Icon',
    'mailingTemplates.details.json': 'Json config',
    'mailingTemplates.details.nameEnglish': 'Name (englisch)',
    'mailingTemplates.details.nameGerman': 'Name (deutsch)',
    'mailingTemplates.details.previewEnglish': 'Vorschau (englisch)',
    'mailingTemplates.details.previewGerman': 'Vorschau (deutsch)',
    'mailingTemplates.details.saveAndClose': 'Speichern und schließen',
    'mailingTemplates.details.type': 'Sendungs-Typ',
    'mailingTemplates.details.visible': 'Sichtbar in Sendungsauswahl',
    'mailingTemplates.h1': 'Sendungsvorlagen',
    'mailingTemplates.name': 'Name',
    'mailingTemplates.position': 'Position',
    'mailingTemplates.type': 'Typ',
    'mailingTemplates.usage': 'Verwendung',
    'modal.cancel': 'Abbrechen',
    'modal.close': 'Schließen',
    'modal.next': 'Weiter',
    'modal.ok': 'Speichern',
    'modal.serverErrors': 'Beim Speichern traten folgende Fehler auf',
    'multiselect.deselectLabel': 'Enter zum Abwählen',
    'multiselect.placeholder': 'Bitte auswählen',
    'multiselect.selectedLabel': 'Ausgewählt',
    'multiselect.selectLabel': 'Enter zum Auswählen',
    'plugins.addFiles': 'Dateien hinzufügen',
    'plugins.create': 'Neues Plugin',
    'plugins.delete': 'Plugin löschen',
    'plugins.deleteConfirm': 'Sind sie sich sicher?',
    'plugins.deleteFile': 'Löschen',
    'plugins.edit': 'Plugin editieren',
    'plugins.editFiles': 'Dateien editieren',
    'plugins.editJson': 'JSON editieren',
    'plugins.editPhp': 'PHP editieren',
    'plugins.editScheduler': 'Scheduler editieren',
    'plugins.editScript': 'Script editieren',
    'plugins.editTemplate': 'Template editieren',
    'plugins.files': 'Dateien',
    'plugins.h1': 'Plugins',
    'plugins.hook': 'Hook - Name der zu erweiternde Frontend Komponente',
    'plugins.internalName': 'Name für Superadmin',
    'plugins.json': 'JSON',
    'plugins.modifiedAt': 'Zuletzt geändert',
    'plugins.name': 'Name',
    'plugins.nameEnglish': 'UI Name (englisch)',
    'plugins.nameGerman': 'UI Name (deutsch)',
    'plugins.newFolder': 'Neuer Ordner',
    'plugins.overview': 'Übersicht',
    'plugins.php': 'PHP',
    'plugins.pluginIsBackend': 'Backend',
    'plugins.pluginIsFrontend': 'Frontend',
    'plugins.scheduleAt': 'Häufigkeit für Scheduler (Laravel Frequency)',
    'plugins.scheduler': 'Scheduler',
    'plugins.script': 'Script',
    'plugins.shortcut': 'Shortcut - Name VueJS Komponente (Unique)',
    'plugins.size': 'Größe',
    'plugins.sync': 'Alle synchronisieren',
    'plugins.syncRunning': 'Wird synchronisiert...',
    'plugins.template': 'Template',
    'sendManager.aborted': 'abgebrochen',
    'sendManager.h1': 'Sendmanager',
    'sendManager.mailingId': 'Mail ID',
    'sendManager.name': 'Accountname / Sendungstitel',
    'sendManager.overview': 'Sendungen',
    'sendManager.planned': 'eingeplant',
    'sendManager.running': 'läuft...',
    'sendManager.sendAt': 'Geplant',
    'sendManager.status': 'Status',
    'sendManager.subscriber': 'Empfänger',
    'sendManager.sync': 'Sendungen synchronisieren',
    'sendManager.syncRunning': 'Wird synchronisiert...',
    'sendManager.transfered': 'gesendet',
    'sendunitPools.create': 'Neuer Pool',
    'sendunitPools.delete': 'Löschen',
    'sendunitPools.deleteConfirm': 'Sind sie sich sicher?',
    'sendunitPools.edit': 'Versandserverpool editieren',
    'sendunitPools.h1': 'Versandserverpool',
    'sendunitPools.name': 'Name',
    'sendunitPools.overview': 'Übersicht',
    'sendunitPools.quality': 'Qualitätstufe',
    'sendunits.create': 'Neuer Versandserver',
    'sendunits.customers': 'Kunden',
    'sendunits.delete': 'Löschen',
    'sendunits.deleteConfirm': 'Sind sie sich sicher?',
    'sendunits.edit': 'Versandserver editieren',
    'sendunits.h1': 'Versandserver',
    'sendunits.login': 'Login',
    'sendunits.overview': 'Übersicht',
    'sendunits.password': 'Passwort',
    'sendunits.pool': 'Pool',
    'sendunits.url': 'URL',
    'settings.h1': 'Einstellungen',
    'settings.maintenanceSwitch': 'Wartungsmodus (global)',
    'settings.maintenanceText': 'Info während dem Wartungsfenster:',
    'settings.maintenanceWarning': 'Ankündigung Wartungsfenster',
    'settings.maintenanceWarningSwitch': 'Ankündigung anzeigen',
    'settings.supportPassword': 'Support Mode Passwort',
    'settings.textEnglish': 'Englische Text',
    'settings.textGerman': 'Deutsche Text',
    'settings.titleEnglish': 'Englische Titel',
    'settings.titleGerman': 'Deutsche Titel',
    'settings.version': 'Neue Version',
    'settings.warningEnglish': 'Englische Warnung',
    'settings.warningGerman': 'Deutsche Warnung',
    'sidebar.accounts': 'Accounts',
    'sidebar.dashboard': 'Dashboard',
    'sidebar.externalIDP': 'Externe IDP',
    'sidebar.idpUser': 'IDP',
    'sidebar.languages': 'Sprachen',
    'sidebar.blacklist': 'Blacklist',
    'sidebar.mailingTemplates': 'Sendungsvorlagen',
    'sidebar.plugin': 'Plugins',
    'sidebar.sendManager': 'Sendmanager',
    'sidebar.sendunit': 'Versandserver',
    'sidebar.sendunitPool': 'Versandserverpool',
    'sidebar.settings': 'Einstellungen',
    'sidebar.statistics': 'Statistiken',
    'sidebar.themes': 'Themes',
    'sidebar.triggerTypes': 'Triggertyp',
    'sidebar.users': 'Benutzer',
    'snippets.code': 'Quelltext',
    'snippets.create': 'Neues Snippet',
    'snippets.delete': 'Löschen',
    'snippets.deleteConfirm': 'Snippet jetzt löschen',
    'snippets.deleteConfirmText': 'Wurden bereits Artikel mit diesem Snippet erstellt, dann sollte das Snippet nur ausgeblendet werden.<br /><br /> Bist du sicher, dass du das Snippet löschen willst?',
    'snippets.edit': 'Snippet editieren',
    'snippets.editCode': 'Quelltext editieren',
    'snippets.h1': 'Snippets',
    'snippets.name': 'Name',
    'snippets.nameEnglish': 'Name (englisch)',
    'snippets.nameGerman': 'Name (deutsch)',
    'snippets.of': 'von',
    'snippets.overview': 'Übersicht',
    'snippets.release': 'Veröffentlichen',
    'snippets.releaseConfirm': 'Wird das Snippet veröffentlicht, dann wird der aktuelle Quelltext gespeichert und sofort in allen Accounts verwendet.<br /><br />Snippets sollten nur veröffentlicht werden, wenn sie vorher getestet wurden.',
    'snippets.releaseConfirmSnippetTestet': 'Snippet wurde getestet',
    'snippets.releaseNow': 'Jetzt veröffentlichen',
    'statistics.currentMonth': 'Aktueller Monat',
    'statistics.dataSize': 'Datenmenge',
    'statistics.day': 'Tag',
    'statistics.h1': 'Statistiken',
    'statistics.h1Extended': 'Versandvolumen nach Monat',
    'statistics.overview': 'Übersicht',
    'statistics.sentNewsletter': 'Versendete Newsletter',
    'statistics.month': 'Jahr/Monat',
    'statistics.mailings': 'Sendungen',
    'statistics.optins': 'Opt-in',
    'statistics.internalES': 'Interne ES',
    'statistics.externalES': 'Externe ES',
    'statistics.totalMailings': 'E-Mails gesamt',
    'statistics.totalSubscribers': 'Empfänger gesamt',
    'statistics.all': 'Alle Accounts',
    'statistics.year': 'Jahr {year}',
    'statusModal.close': 'Schließen',
    'statusModal.confirm': 'Sind sie sicher?',
    'table.actions': 'Aktionen',
    'table.delete': 'Löschen',
    'table.edit': 'Editieren',
    'table.entries': 'Einträgen',
    'table.from': 'von',
    'table.loading': 'Lade...',
    'table.noEntries': 'Keine Einträge vorhanden.',
    'table.reset': 'Zurücksetzen',
    'table.search': 'Suchen...',
    'table.showing': 'Zeige',
    'templates.activeIcon': 'Aktives Icon',
    'templates.code': 'Quelltext',
    'templates.create': 'Neues Template',
    'templates.delete': 'Löschen',
    'templates.deleteConfirm': 'Template jetzt löschen',
    'templates.deleteConfirmText': 'Wurden bereits Artikel mit diesem Template erstellt, dann sollte das Template nur ausgeblendet werden.<br /><br /> Bist du sicher, dass du das Template löschen willst?',
    'templates.descriptionEnglish': 'Beschreibung (englisch)',
    'templates.descriptionGerman': 'Beschreibung (deutsch)',
    'templates.edit': 'Template editieren',
    'templates.editCode': 'Quelltext editieren',
    'templates.editIcon': 'Icon editieren',
    'templates.editJson': 'JSON editieren',
    'templates.h1': 'Templates',
    'templates.icon': 'Icon',
    'templates.icons': 'Icons',
    'templates.json': 'JSON',
    'templates.listPosition': 'Position',
    'templates.name': 'Name',
    'templates.nameEnglish': 'Name (englisch)',
    'templates.nameGerman': 'Name (deutsch)',
    'templates.of': 'von',
    'templates.overview': 'Übersicht',
    'templates.preview': 'Vorschau',
    'templates.release': 'Veröffentlichen',
    'templates.releaseConfirm': 'Wird das Template veröffentlicht, dann wird der aktuelle Quelltext gespeichert und sofort in allen Accounts verwendet.<br /><br />Templates sollten nur veröffentlicht werden, wenn sie vorher getestet wurden.',
    'templates.releaseConfirmTemplateTestet': 'Template wurde getestet',
    'templates.releaseNow': 'Jetzt veröffentlichen',
    'templates.renderIndividually': 'Template einzeln pro Empfänger rendern',
    'templates.renderIndividuallyHint': 'Normal werden Artikel nur einmalig für alle Empfänger gerendert und später für jeden Empfänger nur die Platzhalter ersetzt. Mit diesem Flag kann man steuern, dass Artikel mit diesem Template erst später und pro Empfänger gerendert werden. Dies ist z.B. für Trigger-Artikel notwendig.',
    'templates.TemplateIsAccountAllowed': 'Template ist in allen Accounts aktiviert',
    'templates.TemplateIsFooter': 'Template ist für Footer',
    'templates.TemplateIsHeader': 'Template ist für Header',
    'templates.text': 'Textversion',
    'templates.toActiveIcon': 'Zum aktiven Icon',
    'templates.toNormalIcon': 'Zum normalen Icon',
    'themes.accounts': 'Accounts',
    'themes.addFiles': 'Dateien hinzufügen',
    'themes.allTypes': 'Nutzung für alle Sendungstypen',
    'themes.article': 'Artikel',
    'themes.code': 'Quelltext',
    'themes.collections': 'Listenvorlagen',
    'themes.create': 'Neues Theme',
    'themes.css': 'CSS',
    'themes.delete': 'Löschen',
    'themes.edit': 'Theme editieren',
    'themes.editCode': 'Quelltext editieren',
    'themes.editFiles': 'Dateien editieren',
    'themes.editJson': 'JSON editieren',
    'themes.files': 'Dateien',
    'themes.frontendUse': 'Nur für Frontend',
    'themes.h1': 'Themes',
    'themes.json': 'JSON',
    'themes.mailing': 'Sendungen',
    'themes.modifiedAt': 'Zuletzt geändert',
    'themes.name': 'Name',
    'themes.nameEnglish': 'Name (englisch)',
    'themes.nameGerman': 'Name (deutsch)',
    'themes.newCss': 'Neue CSS Datei',
    'themes.newFolder': 'Neuer Ordner',
    'themes.overview': 'Übersicht',
    'themes.release': 'Veröffentlichen',
    'themes.releaseConfirm': 'Wird das Template veröffentlicht, dann wird der aktuelle Quelltext gespeichert und sofort in allen Accounts verwendet.<br /><br />Templates sollten nur veröffentlicht werden, wenn sie vorher getestet wurden.',
    'themes.releaseConfirmTemplateTestet': 'Template wurde getestet',
    'themes.releaseNow': 'Jetzt veröffentlichen',
    'themes.size': 'Größe',
    'themes.snippets': 'Snippets',
    'themes.sync': 'Alle synchronisieren',
    'themes.syncRunning': 'Wird synchronisiert...',
    'themes.templates': 'Templates',
    'themes.text': 'Textversion',
    'themes.usage': 'Verwendung',
    'themes.useTextVersion': 'Manuelle Textversion aktivieren',
    'triggerTypes.account.assigned': 'Zugewiesen',
    'triggerTypes.account.name': 'Account',
    'triggerTypes.account.selectAll': 'Allen zuweisen',
    'triggerTypes.account.selectNone': 'Keinem zuweisen',
    'triggerTypes.create': 'Neuer Triggertyp',
    'triggerTypes.customer.accounts': 'Accounts',
    'triggerTypes.customer.assigned': 'Zugewiesen',
    'triggerTypes.customer.editTrigger': 'Trigger bearbeiten',
    'triggerTypes.customer.name': 'Kunde',
    'triggerTypes.descriptionEnglish': 'Beschreibung (englisch)',
    'triggerTypes.descriptionGerman': 'Beschreibung (deutsch)',
    'triggerTypes.details.change': 'Ändern',
    'triggerTypes.details.close': 'Schließen',
    'triggerTypes.details.descriptionEnglish': 'Beschreibung (englisch)',
    'triggerTypes.details.descriptionGerman': 'Beschreibung (deutsch)',
    'triggerTypes.details.nameEnglish': 'Name (englisch)',
    'triggerTypes.details.nameGerman': 'Name (deutsch)',
    'triggerTypes.details.saveAndClose': 'Speichern und schließen',
    'triggerTypes.details.type': 'Trigger-Typ',
    'triggerTypes.h1': 'Trigger Typ',
    'triggerTypes.name': 'Name',
    'triggerTypes.nameEnglish': 'Name (englisch)',
    'triggerTypes.nameGerman': 'Name (deutsch)',
    'triggerTypes.optional': 'optional',
    'triggerTypes.overview': 'Übersicht',
    'triggerTypes.shortcut': 'Shortcut',
    'triggerTypes.type': 'Typ',
    'triggerTypes.usage': 'Verwendung',
    'users.active': 'Aktiv',
    'users.create': 'Neuer Benutzer',
    'users.delete': 'Benutzer löschen',
    'users.deleteConfirmText': 'Soll der Benutzer {email} unwiderruflich gelöscht werden?',
    'users.edit': 'Benutzer editieren',
    'users.email': 'E-Mail',
    'users.firstname': 'Vorname',
    'users.h1': 'Benutzer',
    'users.lastname': 'Nachname',
    'users.overview': 'Übersicht',
    'users.password': 'Passwort (mindestens 7 Zeichen)',
    'users.roles': 'Rollen',
    'users.userIsActive': 'Benutzer ist aktiv',
    'variables.account': 'Account',
    'variables.active': 'Aktiv',
    'variables.addition': 'Zusatz',
    'variables.create': 'Variable erstellen',
    'variables.dataType': 'Datentyp',
    'variables.default': 'Standard Wert (optional)',
    'variables.delete': 'Löschen',
    'variables.deleteConfirm': 'Variable jetzt löschen',
    'variables.deleteConfirmText': '',
    'variables.example': 'Beispiel',
    'variables.fieldType': 'Feldtyp',
    'variables.inactive': 'Inaktiv',
    'variables.isAvailableForApi': 'API',
    'variables.isAvailableForDynamicGroups': 'Dynamische Gruppe',
    'variables.isAvailableForExport': 'Export',
    'variables.isAvailableForImport': 'Import',
    'variables.isAvailableForSearch': 'Suche',
    'variables.isAvailableForStatisticsFilter': 'Statistik-Filter',
    'variables.isAvailableForSubscribersDetails': 'Empfänger-Details',
    'variables.isAvailableForSubscribersFilter': 'Empfänger-Filter',
    'variables.isEditable': 'Editable',
    'variables.isSearchable': 'Searchable',
    'variables.mailing': 'Sendung',
    'variables.name': 'Name',
    'variables.nameEnglish': 'Name (Englisch)',
    'variables.nameGerman': 'Name (Deutsch)',
    'variables.of': 'von',
    'variables.operations': 'Operatoren für dynamische Gruppen',
    'variables.readOnly': 'Read only',
    'variables.status': 'Status',
    'variables.subscriber': 'Empfänger',
    'variables.true': 'Wahr',
    'variables.false': 'Falsch',
    'variables.useFor': 'Freigegeben für (abhängig von Variablen- und Datentyp)',
    'variables.variableType': 'Variablentyp',
  }
}



// WEBPACK FOOTER //
// ./src/lang/de.js